import { CreateRounded } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import moment from 'moment/moment'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'
import CustomChip from '../../../../../shared/components/CustomChip'
import HiddenMobile from '../../../../../shared/styles/HiddenMobile'
import { isClient, isCommercial } from '../../../utils/RolesHelper'
import CustomVerifiedIcon from '../CustomVerifiedIcon'

interface DesktopGeneralInfoProps {
  clientTypes: any
  handleClickEdit: any
}

export function DesktopGeneralInfo({ clientTypes, handleClickEdit }: DesktopGeneralInfoProps) {
  const { t } = useTranslation(['global'])

  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  const roleId = userProfileSelected.role_id
  return (
    <Grid xs={12} md={9}>
      <HiddenMobile>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <Typography sx={theme => ({ color: theme.palette.grey[800], fontWeight: '500' })} variant="h5">
              {userProfileSelected.name}
            </Typography>
            <CustomVerifiedIcon value={userProfileSelected.verification} />
            {userProfileSelected.status === 1 ? <CustomChip type={1} status={0} /> : <CustomChip type={1} status={1} />}
          </Box>
          <Button
            fullWidth={window.innerWidth < 600 && true}
            onClick={handleClickEdit}
            variant="contained"
            color="primary"
            startIcon={<CreateRounded />}
          >
            {t('edit')}
          </Button>
        </Box>

        <Box display="flex" gap={2} alignItems={'center'}>
          <Typography variant="subtitle1" color="textSecondary">
            {userProfileSelected.roleName}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 400 }}>
            |
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 400 }}>
            ID:{userProfileSelected.id}
          </Typography>
          <Box
            display="flex"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            gap={2}
            flexWrap={window.innerWidth < 600 ? 'wrap' : 'nowrap'}
          >
            <Box display="flex" gap={1}>
              {clientTypes[userProfileSelected.client_type] && (
                <Typography variant="body2" color="textSecondary">
                  | {t('admin.people.client-type')}: {clientTypes[userProfileSelected.client_type]}
                </Typography>
              )}
              <Typography variant="body2" color="textSecondary">
                | {`${t('admin.people.last-login')}: `}
                {userProfileSelected.last_login_at === null ? 'Sin datos' : moment(userProfileSelected.last_login_at).format('lll')}
              </Typography>
            </Box>
          </Box>
        </Box>

        {isCommercial(roleId) && (
          <Box pb={1}>
            <Typography variant="subtitle1" style={{ fontWeight: 'lighter', marginBottom: '16px' }}>
              Código comercial: <b>{userProfileSelected.commercial_code}</b>
            </Typography>
          </Box>
        )}

        {isClient(roleId) && userProfileSelected.center !== null && (
          <Typography variant="subtitle1" style={{ fontWeight: 'lighter', marginBottom: '16px' }}>
            Centro: {userProfileSelected.center.name}
          </Typography>
        )}
      </HiddenMobile>
    </Grid>
  )
}
